var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "60", height: "60", viewBox: "0 0 60 60" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "filter",
        { id: "id-25a", width: "159.1%", height: "159.1%", x: "-29.5%", y: "-25%", filterUnits: "objectBoundingBox" },
        React.createElement("feOffset", { dy: "2", "in": "SourceAlpha", result: "shadowOffsetOuter1" }),
        React.createElement("feGaussianBlur", { "in": "shadowOffsetOuter1", result: "shadowBlurOuter1", stdDeviation: "4" }),
        React.createElement("feColorMatrix", { "in": "shadowBlurOuter1", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0568027096 0" })
      ),
      React.createElement("circle", { id: "id-26b", cx: "22", cy: "22", r: "22" })
    ),
    React.createElement(
      "g",
      { transform: "translate(8 6)", fill: "none", fillRule: "evenodd" },
      React.createElement("use", { fill: "#000", filter: "url(#id-25a)", xlinkHref: "#id-26b" }),
      React.createElement("use", { fill: "#FFF", xlinkHref: "#id-26b" }),
      React.createElement("circle", { cx: "22.5", cy: "22.5", r: "16.5", fill: "#109A9F", opacity: ".051" }),
      React.createElement("path", { fill: "#109A9F", d: "M25.133 14.246l3.6 1.899c.164.087.267.257.267.442v12.584c0 .276-.224.5-.5.5-.081 0-.161-.02-.233-.058l-3.134-1.653c-.292-.154-.64-.154-.933 0l-3.4 1.794c-.292.154-.641.154-.933 0l-3.6-1.899c-.164-.087-.267-.257-.267-.442V14.829c0-.276.224-.5.5-.5.081 0 .161.02.233.058l3.134 1.653c.292.154.64.154.933 0l3.4-1.794c.292-.154.641-.154.933 0zM19.5 17c-.276 0-.5.224-.5.5v10c0 .276.224.5.5.5s.5-.224.5-.5v-10c0-.276-.224-.5-.5-.5zm6-1c-.276 0-.5.224-.5.5v10c0 .276.224.5.5.5s.5-.224.5-.5v-10c0-.276-.224-.5-.5-.5z" })
    )
  );
});